import React from 'react';
import { Routes, Route, NavLink, Navigate } from 'react-router-dom';
import { User, Lock, Bell, Database } from 'lucide-react';
import SettingsProfile from './SettingsProfile';
import SettingsPassword from './SettingsPassword';
import SettingsNotifications from './SettingsNotifications';
import SettingsSync from './SettingsSync';

const NAV_ITEMS = [
  { path: 'profile', label: 'Profile', icon: User },
  { path: 'password', label: 'Password & Security', icon: Lock },
  { path: 'notifications', label: 'Notifications', icon: Bell },
  { path: 'sync', label: 'Data Sync', icon: Database },
];

export default function SettingsPage() {
  return (
    <div className="max-w-5xl mx-auto px-4 py-6">
      <h1 className="text-xl font-semibold text-gray-900 mb-6">Settings</h1>

      <div className="flex gap-6">
        {/* Side Navigation */}
        <nav className="w-48 flex-shrink-0">
          <ul className="space-y-1">
            {NAV_ITEMS.map(({ path, label, icon: Icon }) => (
              <li key={path}>
                <NavLink
                  to={path}
                  className={({ isActive }) =>
                    `flex items-center gap-2.5 px-3 py-2 text-sm rounded-md transition-colors ${
                      isActive
                        ? 'bg-primary-50 text-primary-700 font-medium'
                        : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                    }`
                  }
                >
                  <Icon className="w-4 h-4" />
                  {label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        {/* Content Area */}
        <div className="flex-1 min-w-0">
          <div className="bg-white rounded-lg border border-gray-200 p-6">
            <Routes>
              <Route index element={<Navigate to="profile" replace />} />
              <Route path="profile" element={<SettingsProfile />} />
              <Route path="password" element={<SettingsPassword />} />
              <Route path="notifications" element={<SettingsNotifications />} />
              <Route path="sync" element={<SettingsSync />} />
            </Routes>
          </div>
        </div>
      </div>
    </div>
  );
}
